module.exports = __webpack_public_path__ + "img/dressed-woman-2.f7ffb0b0.jpg";